module.exports = __webpack_public_path__ + "img/76.866d1fc1.png";